module.exports = __webpack_public_path__ + "assets/img/ts-1.2576edad.png";